import { BreadcrumbJsonLd, QAPageJsonLd } from 'next-seo';
import Head from 'next/head';
import { images } from '../../Constants/ImageUrls';
import { BrandName } from '../../Constants/ProductPage';
import { getAcceptedSuggestedAnswers } from '../../Utils/questionUtils';
import { getBreadCrumbsJSONldData } from '../../datafetchers/CategoryPage';

export default function QuestionsHead(props) {
  const {
    content,
    title,
    breadCrumbsData,
    tagName,
    commentsData,
    questionData,
  } = props;

  const webUrl = content?.web_url?.toLowerCase();
  const postData = questionData?.post;
  const userQuestion = postData?.content?.message;
  const answerCount = commentsData?.length;
  const created_at = postData?.created_at;

  const questionImage =
    content?.webpImages?.[0] ||
    content?.newFiles?.[0] ||
    content?.feature_endorsed_doctor?.image;

  const { acceptedAnswer, suggestedAnswer } =
    getAcceptedSuggestedAnswers(commentsData);
  const addQASchema =
    userQuestion &&
    commentsData?.length > 0 &&
    (suggestedAnswer.length > 0 || Object.keys(acceptedAnswer).length);
  return (
    <>
      <Head>
        {questionImage && (
          <link rel="preload" as="image" href={questionImage} />
        )}
        <link
          key="canonical"
          rel="canonical"
          href={`https://mylofamily.com${webUrl}`}
        />
        <script
          key="organizationLD"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `{"@context": "https://schema.org",
            "@graph": [{
                "@type": "Organization",
                "name": "${BrandName}",
                "alternateName": "Mylo - Raise Happiness",
                "url": "https://mylofamily.com",
                "logo": "${images.headingLogo}"
            }, {
              "@type": "WebSite",
              "@id": "https://mylofamily.com/#website",
              "url": "https://mylofamily.com/",
              "name": "${BrandName}",
              "publisher": {
                "@id": "https://mylofamily.com/#organization"
              }
            }, {
              "@type": "WebPage",
              "@id": "https://mylofamily.com${webUrl}#webpage",
              "url": "https://mylofamily.com${webUrl}",
              "inLanguage": "en-US",
              "name": "${title.trim()?.replace(/"/gi, '')}",
              "isPartOf": {
                "@id": "https://mylofamily.com/#website"
              },
              "about": {
                "@id": "https://mylofamily.com/#organization"
              },
              "datePublished": "${content?.created_at?.split(' ')?.[0]}",
                "image": {
                "@type": "ImageObject",
                "@id": "#primaryimage",
                "url": "${images.headingLogo}",
                "width": 800,
                "height": 800,
                "caption": ""
              },
              "primaryImageOfPage": {
                "@id": "#primaryimage"
              }
            }]}`,
          }}
        ></script>
      </Head>
      {addQASchema ? (
        <QAPageJsonLd
          mainEntity={{
            name: tagName,
            text: userQuestion,
            answerCount: answerCount,
            // upvoteCount: 26,
            dateCreated: created_at,
            // author: { name: "New Baking User" },
            acceptedAnswer,
            suggestedAnswer,
          }}
        />
      ) : null}
      {breadCrumbsData?.length > 0 ? (
        <BreadcrumbJsonLd
          itemListElements={getBreadCrumbsJSONldData(breadCrumbsData)}
        />
      ) : null}
    </>
  );
}
